import { useMemo } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityDeleteHandlerFactory } from './useEntityDeleteHandlerFactory';

export function useEntityDeleteHandler<TEntityName extends EntityName>(
  entityName: TEntityName,
  entity: AppEntityManagerEntityTypesByEntityName[TEntityName]['entity'],
  getName: (
    entity: AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']
  ) => string
): () => void {
  const factory = useEntityDeleteHandlerFactory({
    entityName,
    getName
  });

  return useMemo(() => {
    return factory(entity);
  }, [factory, entity]);
}
